<template>
    <div class="row">
        <div class="col col-lg-12 col-md-12">
            <div class="sorting">
                <span class="avafont-sorting"></span>
                <h6>نمایش براساس:</h6>
                <ul class="filtersType">
                    <li
                        v-for="option in sortOptions"
                        :class="{
                            active: value.sort === option.id
                        }"
                        :key="option.id"
                        v-on:click="setActiveSort(option.id)"
                    >
                        {{ option.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { PRODUCT_LIST_CONSTANTS } from '@/constants/constants.js';

    const sortOptions = PRODUCT_LIST_CONSTANTS.sortOptions;

    export default {
        name: 'GridHeader',
        props: {
            value: {
                type: Object,
                default: {}
            }
        },
        computed: {
            sortOptions: () => sortOptions
        },
        methods: {
            setActiveSort(sortId) {
                this.$emit('input', { ...this.value, sort: sortId });
            }
        }
    };
</script>
